export default __webpack_public_path__ + "static/media/FS9A0049-2.f1d9d78f.png";